/* eslint-disable @typescript-eslint/no-floating-promises */
import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { fetchGet } from '../../../store/fetch';
import { EditPanelSelect, ISelectOption, Panel } from '../../elements';

export function SurveySelection(props: { objectId: string; onChange(value: string): void }) {
    const translate = useTranslate();
    const [surveys, setSurveys] = React.useState<ISelectOption[]>([]);
    const [surveyId, setSurveyId] = React.useState<undefined | string>();

    React.useEffect(() => {
        (async () => {
            const responseSurveys = await fetchGet('/api/surveys', { objectId: props.objectId });
            setSurveys(
                responseSurveys.json.items.map((survey: { id: string; description: string }) => ({ text: survey.description, value: survey.id })),
            );
        })();
    }, [props.objectId]);

    return (
        <>
            <Panel>
                <EditPanelSelect
                    name="surveyId"
                    placeholder={translate('common.survey')}
                    value={surveyId}
                    options={surveys}
                    handleChange={(value) => {
                        setSurveyId(value);
                        props.onChange(value);
                    }}
                />
            </Panel>
        </>
    );
}
